<template>
  <AccountShell />
</template>

<script setup lang="ts">
import { AccountShell } from "@/shared/account";
</script>
